import { create } from "zustand";
import { toast } from "react-toastify";

/* =======================
   TYPE
======================= */
export type SalaryForm = {
  currentSalary: string; // dari form (string angka)
  currentSalaryMethod: "gross" | "nett";
  expectedSalary: string;
  expectedSalaryMethod: "gross" | "nett";
  negotiable: boolean;
};

/* =======================
   STORE
======================= */
type SalaryState = {
  loading: boolean;
  updateSalary: (data: SalaryForm) => Promise<boolean>;
};

const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch (e) {
    console.error("❌ Failed to parse auth token:", e);
    return null;
  }
};

export const useSalaryStore = create<SalaryState>((set) => ({
  loading: false,

  updateSalary: async (data) => {
    try {
      set({ loading: true });

      const token = getAccessToken();
      if (!token) throw new Error("No access token");

      const payload = {
        current_salary: Number(data.currentSalary),
        current_salary_method: data.currentSalaryMethod,
        expected_salary: Number(data.expectedSalary),
        expected_salary_method: data.expectedSalaryMethod,
        is_negotiable: data.negotiable,
      };

      const res = await fetch(
        "https://admin.talentlinkindo.com/api/candidate/salary",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Update salary failed");

      toast.success("Salary updated successfully");
      return true;
    } catch (err) {
      console.error(err);
      toast.error("Failed to update salary");
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
